import { computed, Directive, HostListener, inject, input } from '@angular/core'
import { LoadingSpinnerService } from '../public/spinner/loading-spinner.service'
import { RouterLink } from '@angular/router'

const urlCheckInterval = 250
const maxUrlChecks = 40

const getPath = () => window.document.location.pathname

@Directive({
  selector: 'a[navLink]',
  hostDirectives: [
    {
      directive: RouterLink,
      inputs: [
        'routerLink: navLink',
      ],
    },
  ],
})
export class NavLinkDirective {
  private readonly loadingSpinnerService = inject(LoadingSpinnerService)

  readonly navLink = input.required<string>()

  private readonly targetPath = computed((): string => {
    // strip off query params, hash
    const url = URL.parse(`https://host${this.navLink()}`)
    if (url) {
      return url.pathname
    } else {
      // path is malformed.... just bail
      return ''
    }
  })

  private disabled = computed((): boolean => this.targetPath() === '')

  // show the spinner while the router is doing whatever it's doing to give the user feedback
  // hide when the path changes
  private waitForPathChange(originalPath: string) {
    let urlChecks = 0
    this.loadingSpinnerService.handleRequest('plus')

    const checkForPathChange = () => {
      urlChecks++
      if (getPath() !== originalPath || urlChecks === maxUrlChecks) {
        this.loadingSpinnerService.handleRequest('minus')
      } else {
        window.setTimeout(checkForPathChange, urlCheckInterval)
      }
    }

    window.setTimeout(checkForPathChange, urlCheckInterval)
  }

  @HostListener('click')
  onClick() {
    if (!this.disabled()) {
      const originalPath = getPath()
      // if only query params are changing or nothing is changing don't do anything
      if (originalPath !== this.targetPath()) {
        this.waitForPathChange(originalPath)
      }
    }
  }
}
